import { text_to_slug } from "../../../util/methods"

// sluggify shop name
$(document).on("keyup", "#shop_name", function () {
  $("#shop_slug")
    .val(text_to_slug($(this).val()))
    .trigger("input")
})
